var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvertedComma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 75,
    viewBox: "0 0 100 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 75V37.5H75C75 23.719 86.206 12.5 100 12.5V0C79.321 0 62.5 16.821 62.5 37.5V75H100Z",
    fill: "url(#paint0_linear_1_3481)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 75V37.5H12.5C12.5 23.719 23.706 12.5 37.5 12.5V0C16.821 0 0 16.821 0 37.5V75H37.5Z",
    fill: "url(#paint1_linear_1_3481)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_3481",
    x1: 81.25,
    y1: 0,
    x2: 81.25,
    y2: 75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF8DFF",
    stopOpacity: 0.13
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_3481",
    x1: 18.75,
    y1: 0,
    x2: 18.75,
    y2: 75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF8DFF",
    stopOpacity: 0.13
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvertedComma);
export default __webpack_public_path__ + "static/media/invertedComma.915bd9278e17b4509e0909a17f4bb499.svg";
export { ForwardRef as ReactComponent };